<template>
  <div>
    <div v-if="!isReadOnly" class="my-4">
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="">
            <div class="row d-flex align-items-end">
              <div class="col-12 col-md-4">
                <label class="font-weight-bolder">Equipo:</label>
                <custom-input
                  v-model="model.name"
                  :disabled="false"
                  fieldkey="id"
                  fieldname="name"
                  placeholder=""
                />
              </div>
              <action-button
                :disabled="false"
                i="fas fa-file-plus"
                text="Añadir"
                variant="success col-12 col-md-2 px-0"
                @click="add()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <custom-collapse id="equipments-collapse">
        <custom-collapse-item
          v-for="(item, key) in value"
          :id="`equipment-collapse-item-${key + 1}`"
          :key="`equipment-collapse-item-${key + 1}`"
          :ref="`equipment-collapse-item-${key + 1}`"
          :auto-expand-collapse-enabled="false"
          :button-icon="
            !isReadOnly ? 'far fa-times-circle color-red invalid' : ''
          "
          class="my-3 collapse-item equipment bg-gray"
          :class="{ 'rounded invalid': item.isValid === false }"
          :disabled="false"
          :expanded="item.expanded"
          expanded-icon="fas fa-plus-circle custom-reorganize-btn"
          icon-class-when-button-disabled="fas fa-grip-vertical flex-fill d-flex justify-content-end align-items-center"
          :keep-btn-visible="false"
          parent-id="equipments-collapse"
          read-only-icon="fas fa-plus-circle color-gray-2"
          :title="item.name"
          @actionButtonClick="quit(item, key)"
          @expandButtonClick="expand(item, key)"
        >
          <template #title-left>
            <span v-if="item.isValid === false" class="badge badge-danger ml-2">
              Atención
            </span>
          </template>
          <validation-observer :ref="`equipmentObservers-${key}`">
            <validation-provider
              v-if="!isReadOnly"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El campo es requerido.',
              }"
              rules="required"
            >
              <custom-text-area
                v-model="item.description"
                :count-classes="['d-block', 'small-counter']"
                :custom-error-msg="errors[0]"
                :error="errors[0]"
                label="Descripción:"
                :maxlength="3000"
                show-char-count
              />
            </validation-provider>
            <div v-else-if="isReadOnly">
              <div class="my-2">
                Descripción:
              </div>
              <label class="data-label">
                {{ item.description | empty }}
              </label>
            </div>
            <validation-provider
              v-if="!isReadOnly"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El campo es requerido.',
              }"
              rules="required"
            >
              <custom-text-area
                v-model="item.qualifications"
                :count-classes="['d-block', 'small-counter']"
                :custom-error-msg="errors[0]"
                :error="errors[0]"
                label="Especificaciones:"
                :maxlength="3000"
                show-char-count
              />
            </validation-provider>
            <div v-else-if="isReadOnly">
              <div class="my-2">
                Especificaciones:
              </div>
              <label class="data-label">
                {{ item.qualifications | empty }}
              </label>
            </div>
            <validation-provider
              v-if="!isReadOnly"
              v-slot="{ errors }"
              :custom-messages="{
                required: 'El campo es requerido.',
              }"
              rules="required"
            >
              <custom-text-area
                v-model="item.resources"
                :count-classes="['d-block', 'small-counter']"
                :custom-error-msg="errors[0]"
                :error="errors[0]"
                label="Recursos del Equipo:"
                :maxlength="3000"
                show-char-count
              />
            </validation-provider>
            <div v-else-if="isReadOnly">
              <div class="my-2">
                Recursos del Equipo:
              </div>
              <label class="data-label">
                {{ item.resources | empty }}
              </label>
            </div>
          </validation-observer>
        </custom-collapse-item>
      </custom-collapse>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomCollapse from '@/components/common/CustomCollapse.vue';
import CustomCollapseItem from '@/components/common/CustomCollapseItem.vue';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import CustomTextArea from 'CustomTextArea';

export default {
  name: 'Equipments',
  components: {
    ActionButton,
    CustomInput,
    CustomCollapse,
    CustomCollapseItem,
    CustomTextArea,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      model: {
        name: '',
      },
    };
  },
  computed: {
    allExpanded() {
      return this.value.every((item) => item.expanded);
    },
  },
  methods: {
    async validateAndMark() {
      await this.$nextTick();

      let allOk = true;

      for (let i = 0; i < this.value.length; i++) {
        const refKey = `equipmentObservers-${i}`;
        const arr = this.$refs[refKey];
        const observer = Array.isArray(arr) ? arr[0] : arr;
        if (!observer || typeof observer.validate !== 'function') continue;

        const ok = await observer.validate();
        this.$set(this.value[i], 'isValid', ok);

        if (!ok) {
          allOk = false;
          this.expand(this.value[i], i);
        }
      }

      return allOk;
    },
    resetForm() {
      this.model.name = null;
    },
    async add() {
      if (!this.model.name || !this.model.name?.trim()) {
        this.ShowToast('Alerta', 'Favor asignar un nombre al equipo.', 'error');
        return;
      }
      const item = {
        name: this.model.name,
        expanded: false,
      };
      this.value.push(item);
      this.resetForm();
      this.expand(item, this.value.length - 1);
    },
    expand(item, key) {
      this.value
        .filter((x, i) => i !== key)
        .forEach((x) => (x.expanded = false));
      setTimeout(() => (item.expanded = !item.expanded), 100);
    },
    async quit(item, key) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea eliminar este equipo de la solicitud?`,
        'Si',
        'No'
      );

      if (!answer) return;
      this.value.splice(key, 1);
      this.$emit('quit', item);
    },
  },
};
</script>

<style scoped lang="scss">
.outline-dark-gray {
  color: #3f5b60;
  background-color: #ffffff;
  border-color: #3f5b60;
}

.collapse-item ::v-deep .card-header {
  padding: 0.75rem 1rem !important;
}

.collapse-item ::v-deep .tag-badge-pei {
  background: none;
}

.collapse-item.equipment ::v-deep .shadow2 {
  -webkit-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  box-shadow: none !important;
  background-color: #f7f7f7;
}
.collapse-item.equipment ::v-deep .card-header {
  border-radius: 0.25rem !important;
  border-bottom: 2px solid #e6e6e6;
}
.collapse-item.equipment ::v-deep .card-header .title-number-box {
  background-color: #2db782;
}

.collapse-item.invalid.equipment {
  border: 1px solid #ff0018 !important;
}
.collapse-item.invalid.equipment ::v-deep .card-header .title-number-box {
  background-color: #ff5b5c !important;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.custom-reorganize-btn {
  background-color: #405c64;
}
.equipment-title > div {
  border: 3px solid white;
  padding: 6px 7px;
  border-radius: 30px;
  -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
}
</style>
